"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostMessageToMobileApp = exports.postMessageToMobileApp = void 0;
const react_1 = require("react");
/**
 * Sends a message to the mobile app's WebView.
 * @param message - The message to send.
 * @param options - Optional options for handling the message.
 * @returns A promise that resolves to the message response.
 */
const postMessageToMobileApp = (message, options) => {
    return new Promise((resolve, reject) => {
        var _a, _b, _c, _d;
        try {
            const messageToSend = JSON.stringify(message);
            // For Android WebView
            if (typeof ((_a = window.nativeMessagesHandler) === null || _a === void 0 ? void 0 : _a.postMessage) === "function") {
                window.nativeMessagesHandler.onmessage = (event) => {
                    var _a;
                    const parsedData = JSON.parse(event.data);
                    // Android currently returns the full message object, while iOS returns just the response.
                    // This handles the difference until Android is updated to match iOS behavior.
                    // TODO: Once Android is updated and its latest version fully adopted, we can remove this logic.
                    const responseData = parsedData &&
                        typeof parsedData === "object" &&
                        "response" in parsedData
                        ? parsedData.response
                        : parsedData;
                    (_a = options === null || options === void 0 ? void 0 : options.onMessageSuccess) === null || _a === void 0 ? void 0 : _a.call(options, responseData);
                    window.onmessage = null;
                    resolve(responseData);
                };
                window.nativeMessagesHandler.postMessage(messageToSend);
                return;
            }
            // For iOS WebView
            if (((_b = window.webkit) === null || _b === void 0 ? void 0 : _b.messageHandlers) &&
                typeof ((_c = window.webkit.messageHandlers.nativeMessagesHandler) === null || _c === void 0 ? void 0 : _c.postMessage) === "function") {
                window.webkit.messageHandlers.nativeMessagesHandler
                    .postMessage(messageToSend)
                    .then((response) => {
                    var _a;
                    (_a = options === null || options === void 0 ? void 0 : options.onMessageSuccess) === null || _a === void 0 ? void 0 : _a.call(options, response);
                    resolve(response);
                })
                    .catch((error) => {
                    reject(error);
                });
                return;
            }
            throw new Error("No native message handler available");
        }
        catch (error) {
            (_d = options === null || options === void 0 ? void 0 : options.onError) === null || _d === void 0 ? void 0 : _d.call(options, error, message);
            reject(error);
        }
    });
};
exports.postMessageToMobileApp = postMessageToMobileApp;
/**
 * React hook that provides a function to send messages to the mobile app's WebView.
 * Implementation according to #RFC: MOBILE-52531 App ↔ webview communication
 * https://docs.google.com/document/d/1NnjC1Yv9AJz0_WlTxVGYkWBMKhwHgZTKq0p2OIfjjnk/edit?tab=t.0#heading=h.rk3clrckllzn
 * @returns An object containing the `postMessage` function.
 */
const usePostMessageToMobileApp = () => {
    return {
        postMessage: (0, react_1.useCallback)(exports.postMessageToMobileApp, []),
    };
};
exports.usePostMessageToMobileApp = usePostMessageToMobileApp;
//# sourceMappingURL=index.js.map